var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadFileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84615 1.5C2.55041 1.5 1.5 2.55041 1.5 3.84615V11C1.5 12.933 3.067 14.5 5 14.5C6.933 14.5 8.5 12.933 8.5 11V5.75C8.5 5.33579 8.83579 5 9.25 5C9.66421 5 10 5.33579 10 5.75V11C10 13.7614 7.76142 16 5 16C2.23858 16 0 13.7614 0 11V3.84615C0 1.72198 1.72198 0 3.84615 0C5.97033 0 7.69231 1.72198 7.69231 3.84615V10.9519C7.69231 12.3592 6.55149 13.5 5.14423 13.5C3.73697 13.5 2.59615 12.3592 2.59615 10.9519V3.75C2.59615 3.33579 2.93194 3 3.34615 3C3.76037 3 4.09615 3.33579 4.09615 3.75V10.9519C4.09615 11.5308 4.56539 12 5.14423 12C5.72307 12 6.19231 11.5308 6.19231 10.9519V3.84615C6.19231 2.55041 5.1419 1.5 3.84615 1.5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-file-icon.76cc0da6166d5f355a76e5783de4c721.svg";